require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es6.typed.int8-array.js
// module id = 384
// module chunks = 0